import { AlertTitle, Box, Typography, useMediaQuery } from '@mui/material'
import Alert from '@mui/material/Alert'
import React from 'react'
import { When } from 'react-if'
import { BREAKPOINT_MIN_SM } from 'Theme/stylesUtil'

import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'
import { getFormattedDate, getFullDateInDetails } from '../../../utils/date-utils'
import { PAYMENTS_STATES } from '../../../utils/payments-utils'
import TrophyIcon from '../../_common/TrophyIcon'
import { getPlaceName, getPlaceTrophyIconName } from '../PrizeCard/constants'

const ProfilePayments = React.lazy(() => import('Scenes/Profile/ProfilePayments/ProfilePayments'))

const ContestsPaymentPlate = ({ contestId, paymentInfo, contestEndTime, rewards }) => {
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const titleFontSize = isBiggerThanSMScreen ? '24px' : '14px'
  const textVariant = isBiggerThanSMScreen ? 'h6' : 'body'
  const padding = isBiggerThanSMScreen ? '24px 40px' : '16px 8px'
  const iconMarginRight = isBiggerThanSMScreen ? '24px' : '12px'
  const iconMarginLeft = isBiggerThanSMScreen ? '0px' : '12px'
  const paymentPrize =
    rewards?.reduce((sum, reward) => sum + reward?.prizing?.[0]?.value, 0) ||
    paymentInfo?.rewards?.prizing?.[0]?.value ||
    0
  const place =
    rewards?.map((reward) => getPlaceName(reward?.prizing?.[0]?.place)).join(', ') || getPlaceName(paymentInfo.place)
  return (
    <Alert
      sx={(theme) => ({
        padding,
        marginY: '24px',
        marginX: 0,
        borderRadius: '16px',

        '& .MuiAlert-icon': {
          alignItems: 'center',
          marginRight: iconMarginRight,
          marginLeft: iconMarginLeft,
        },
        '& .MuiAlertTitle-root': {
          ...theme.typography.h3,
          color: theme.palette.text.primary,
        },
        '& .MuiAlert-message': {
          color: theme.palette.text.tertiary,
          padding: 0,
        },
        '& .MuiAlert-action': {
          alignItems: 'center',
        },
      })}
      style={{ background: 'linear-gradient(270.66deg, #202126 0%, #202933 100%)' }}
      icon={
        <TrophyIcon
          place={paymentInfo?.is_community ? 'liked' : getPlaceTrophyIconName(paymentInfo?.place)}
          withNumberInGoblet={!paymentInfo?.is_community}
          number={paymentInfo?.place}
        />
      }
    >
      <AlertTitle style={{ fontSize: titleFontSize }}>Victory</AlertTitle>
      <Typography
        variant={textVariant}
        color="text.secondary"
      >
        Congratulations! Your map(s) won {place} place(s) in the contest and will be awarded ${paymentPrize}!
      </Typography>
      <Box sx={{ display: 'flex', marginLeft: '-5px', marginTop: '10px' }}>
        <FAIcon iconClassName={FA_ICONS.CALENDAR} /> {getFormattedDate(contestEndTime)}
      </Box>
      <When condition={PAYMENTS_STATES[0] === paymentInfo.payment_state}>
        <Box sx={{ marginTop: '20px' }}>
          <ProfilePayments contestId={contestId} />
        </Box>
      </When>
      <When condition={PAYMENTS_STATES[1] === paymentInfo.payment_state}>
        <Typography
          variant="h4"
          color="text.secondary"
          sx={{ marginTop: '25px' }}
        >
          Payout information has been sent on {getFullDateInDetails(paymentInfo.time_info_received)}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
        >
          We'll send you an email confirmation, after the payout will be complete. It can take about one to two weeks.
        </Typography>
      </When>
      <When condition={PAYMENTS_STATES[2] === paymentInfo.payment_state}>
        <Typography
          variant="body2"
          color="primary.main"
        >
          We sent your reward on {getFullDateInDetails(paymentInfo.time_rewarded)}
        </Typography>
      </When>
    </Alert>
  )
}

export default ContestsPaymentPlate
